import React from 'react';
import {
  appCardStyle,
  appChipSize,
  appChipStyle,
  appIconsPath,
  appInfoCardSize
} from '@utils/globalConstant';
import { Chip } from '@core/Chip';

export const CardTeaser = ({
  cardStyle = appCardStyle.PRIMARY,
  cardSize = appInfoCardSize.DEFAULT,
  chipStyle = appChipStyle.SECONDARY,
  chipIcon = null,
  chipLabel = '',
  text = '',
  imgSrc,
  imgHeight = '100%',
  imgAlt = ''
}) => {
  const chipSize = cardSize === appInfoCardSize.DEFAULT ? appChipSize.DEFAULT : appChipSize.LARGE;
  return (
    <div className={`${cardStyle} rounded-3 overflow-hidden`}>
      <div className="row g-0">
        <div className="col-6 d-flex flex-column justify-content-between p-12">
          <div className="col-12">
            <Chip chipStyle={chipStyle} chipSize={chipSize} icon={chipIcon} label={chipLabel} />
          </div>
          <div className="pt-12" dangerouslySetInnerHTML={{ __html: text }} />
        </div>
        <div className="col-6 p-0">
          <img
            src={imgSrc}
            alt={imgAlt}
            style={{ objectFit: 'cover', height: imgHeight, width: '100%' }}
          />
        </div>
      </div>
    </div>
  );
};

export default CardTeaser;
